import { render, staticRenderFns } from "./ExpansionPanelHeader.vue?vue&type=template&id=f633b9a0&scoped=true"
import script from "./ExpansionPanelHeader.vue?vue&type=script&lang=js"
export * from "./ExpansionPanelHeader.vue?vue&type=script&lang=js"
import style0 from "./ExpansionPanelHeader.vue?vue&type=style&index=0&id=f633b9a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f633b9a0",
  null
  
)

export default component.exports